module.exports = __webpack_public_path__ + "static/media/9CreacionFactura-09.8f5b8f74.png";